import React from 'react'
import PropTypes from 'prop-types'

const timeProgrammSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
        <g>
            <path
                d=" M 10.746 17.128 L 3.414 17.128 L 3.414 11.934 L 16.295 11.934 C 16.525 12.205 16.867 12.377 17.25 12.377 C 17.633 12.377 17.975 12.205 18.205 11.934 L 20.068 11.934 L 20.068 13 L 22 11.107 L 20.068 9.255 L 20.068 10.383 L 18.254 10.383 C 18.026 10.076 17.661 9.877 17.25 9.877 C 16.839 9.877 16.474 10.076 16.246 10.383 L 3.414 10.383 L 3.414 4.854 L 5.295 4.854 C 5.525 5.125 5.867 5.297 6.25 5.297 C 6.633 5.297 6.975 5.125 7.205 4.854 L 20.068 4.854 L 20.068 5.92 L 22 4.027 L 20.068 2.174 L 20.068 3.303 L 7.254 3.303 C 7.026 2.996 6.661 2.797 6.25 2.797 C 5.839 2.797 5.474 2.996 5.246 3.303 L 3.414 3.303 L 3.414 1.828 L 2 1.828 L 2 20 L 3.414 20 L 3.414 18.679 L 10.795 18.679 C 11.025 18.95 11.367 19.123 11.75 19.123 C 12.133 19.123 12.475 18.95 12.705 18.679 L 20.068 18.679 L 20.068 19.745 L 22 17.853 L 20.068 16 L 20.068 17.128 L 12.754 17.128 C 12.526 16.822 12.161 16.623 11.75 16.623 C 11.339 16.623 10.974 16.822 10.746 17.128 Z "
                fillRule="evenodd" fill={color}/>
        </g>
    </svg>
)

timeProgrammSVG.defaultProps = {
    color: '#2D3190',
    width: 24,
    height: 24,
}

timeProgrammSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (timeProgrammSVG)
